import includes from 'lodash/includes'
import uniq from 'lodash/uniq'
import {
  MIN_SUPPORTED_ASSESSMENT_GRADE,
  MAX_SUPPORTED_ASSESSMENT_GRADE
} from '@freckle/educator-entities/ts/common/helpers/constants'
import type {CourseAttrs} from '@freckle/educator-entities/ts/roster/models/course'
import type {CourseMembershipAttrs} from '@freckle/educator-entities/ts/roster/models/course-membership'
import type {StudentAttrs} from '@freckle/educator-entities/ts/users/models/student'
import type {BaseTeacherAttrs} from '@freckle/educator-entities/ts/users/models/teacher'

function isStudentGradeInRange(student: StudentAttrs): boolean {
  const minGrade = MIN_SUPPORTED_ASSESSMENT_GRADE
  const maxGrade = MAX_SUPPORTED_ASSESSMENT_GRADE
  return minGrade <= student.grade && student.grade <= maxGrade
}

export function getAllStudentsBySchool(
  schoolId: number,
  teachers: Array<BaseTeacherAttrs>,
  courses: Array<CourseAttrs>,
  cms: Array<CourseMembershipAttrs>,
  students: Array<StudentAttrs>
): Array<StudentAttrs> {
  const teacherIdsInSchool = teachers
    .filter(teacher => teacher.schoolId === schoolId)
    .map(teacher => teacher.id)

  const courseIdsInSchool = courses
    .filter(course => includes(teacherIdsInSchool, course.teacherId))
    .map(course => course.id)

  const studentIdsInSchool = uniq(
    cms.filter(cm => includes(courseIdsInSchool, cm.courseId)).map(cm => cm.studentId)
  )

  return students.filter(
    student => includes(studentIdsInSchool, student.id) && isStudentGradeInRange(student)
  )
}
